export const getRandomTestVariant = (doc) => {
  if (!doc.testsEnabled || !doc.tests?.length) {
    return doc;
  }
  const randomIndex = Math.floor(Math.random() * doc.tests?.length);
  return {
    ...doc,
    ...doc.tests[randomIndex],
    testId: doc.tests[randomIndex]?.id,
    id: doc.id || doc._id
  };
};
